import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { getQuestionnaireItems } from "@/api/endpoints/maturity";

export function useGetQuestionnaireItems(assuranceLevel: string | undefined) {
  return useQuery({
    queryKey: queryKeys.maturity.questionnaire(assuranceLevel || ""),
    queryFn: () => getQuestionnaireItems(assuranceLevel),
    staleTime: Infinity,
    enabled: !!assuranceLevel,
  });
}
